module.exports = __webpack_public_path__ + "img/smart4.f9cd0634.svg";